/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="37px"
        height="38px"
        viewBox="0 0 37 38"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <g
          fill="none"
          transform="translate(.5 .775)"
          fillRule="evenodd">
          <circle
            cx="18.144"
            cy="18.144"
            r="18.144"
            fill="#1570BC"
            className="icon-fill"/>
          <path
            stroke="#FFF"
            d="M25.426 17.7H11.1"
            className="icon-color"
            strokeWidth="3.456"
            strokeLinecap="square"/>
        </g>
      </svg>
    );
  }
}

Icon.displayName = 'MinusSignFillIcon';

export default Icon;
